import { nbsLabels } from './labels';

export const formatMtnWithDecimals = (mtn) => {
  let formattedMtn = null;
  if (!mtn) {
    return '';
  }
  formattedMtn = mtn.toString();
  formattedMtn = `${formattedMtn.substring(0, 3)}.${formattedMtn.substring(3, 6)}.${formattedMtn.substring(6, 10)}`;
  return formattedMtn;
};

export const formatCurrency = (value) => {
  const emptySpace = '\xa0';
  if (value === undefined) return '';
  if (value === '$NaN') return '';
  const sign = value < 0 ? '-' : emptySpace;
  const numValue = Number(Math.abs(value)).toFixed(2);
  const currencyString = `${sign}$${numValue}`;
  return currencyString;
};

export const convertDates = (dateValue) => {
  const date1 = new Date(dateValue);
  const formattedDate = `${date1.toLocaleString('en', {
    month: 'short',
  })} ${date1.toLocaleString('en', { day: '2-digit' })}`;

  return formattedDate;
};

export const convertDate = (dateValue) => {
  if (dateValue !== undefined && dateValue !== '') {
    const date1 = new Date(dateValue);
    const formattedDate = date1.toLocaleString('en', { month: 'short' });
    return formattedDate;
  }
  return '';
};

export const convertBillDates = (dateRange) => {
  const dates = dateRange?.split('-');
  const formattedDate = dates && dates[0] ? convertDates(dates[0]) : null;
  return formattedDate ? `(${formattedDate})` : '';
};

export const formatDay = (d) => {
  if (parseInt(d) > 3 && parseInt(d) < 21) return `${d}th`;
  switch (d % 10) {
    case 1:
      return `${d}st`;
    case 2:
      return `${d}nd`;
    case 3:
      return `${d}rd`;
    default:
      return `${d}th`;
  }
};


export const FwaSetupIndicator = (messageType, dbrFlag) => {
  let msg = '';
  if (messageType === 'D') {
    msg = dbrFlag ? nbsLabels.billingChargesDfill : nbsLabels.setupChargesDelivery;
  } else if (messageType === 'P') {
    msg = dbrFlag ? nbsLabels.billingChargesPro : nbsLabels.setupChargesPro;
  } else if (messageType === 'L') {
    msg = dbrFlag ? nbsLabels.billingChargesIspu : nbsLabels.setupCharges;
  } else {
    msg = dbrFlag ? "" : nbsLabels.setupCharges;  
  }
  return msg;
};

export const whwNBSFlag = (spoCategoryCodeList) => {
  let flag = false;
  if (spoCategoryCodeList) {
    spoCategoryCodeList.forEach((item) => {
      if (item?.spoCategoryCode?.includes('WHWPLUS') || item?.spoCategoryCode?.includes('WHWBASIC')) {
        flag = true;
      }
    });
  }
  return flag;
};

export const isWHWPlusSPO = (spoCategory) => {
  let flag = false;
  if (spoCategory) {
    spoCategory.forEach((item) => {
      if (item?.spoCategoryCode?.includes('WHWPLUS')){
        flag = true;
      }
    });
  }
  return flag;
};

export const getExtenderQuantity = (spoCategoryCodeList) => {
  let extenderQuantityText = '';
  let extenderQuantity = '';
  const { whwPlusQuantity, whwBasicQuantity } = window.vzFlags || {};
  if (spoCategoryCodeList[0]?.spoCategoryCode === 'WHWPLUS') {
    extenderQuantity = whwPlusQuantity;
  } else if (spoCategoryCodeList[0]?.spoCategoryCode === 'WHWBASIC') {
    extenderQuantity = whwBasicQuantity;
  }
  if (extenderQuantity && extenderQuantity !== '') {
    extenderQuantityText = extenderQuantity === '1' ? `${extenderQuantity} extender included` : `${extenderQuantity} extenders included`;
  }
  return extenderQuantityText;
};
